var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 21,
    fill: "#0C1525",
    stroke: "url(#paint0_linear_9501_68796)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_68796)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4728 20.1089C24.1488 18.8431 26.3163 18.4244 28.343 18.975L28.3484 18.9127C28.3608 18.7693 28.3729 18.6307 28.3729 18.4864C28.3733 15.2187 25.7246 12.5695 22.4569 12.5691C19.1892 12.5687 16.54 15.2174 16.5396 18.485V18.4864C16.5396 18.6438 16.5537 18.8011 16.5679 18.9584L16.5703 18.9841C18.6058 18.4242 20.7859 18.8396 22.4728 20.1089ZM21.8491 23.5296C22.2625 23.5792 22.6804 23.5775 23.0933 23.5247C22.931 23.1373 22.7218 22.7712 22.4704 22.4348C22.2195 22.773 22.0108 23.1407 21.8491 23.5296ZM28.9992 20.1288C29.3646 20.2925 29.7125 20.493 30.0373 20.727C32.6845 22.6343 33.2843 26.3263 31.377 28.9734C29.4698 31.6205 25.7777 32.2203 23.1306 30.3131C24.4336 29.048 25.1673 27.3083 25.1637 25.4922C25.1622 25.2206 25.1439 24.9494 25.1089 24.6801C27.0418 23.8491 28.4791 22.1675 28.9992 20.1288ZM19.7837 25.4922C19.7847 25.2259 19.8022 24.96 19.836 24.6959C17.8934 23.8777 16.4433 22.2007 15.9142 20.1603C12.9539 21.5342 11.6679 25.0477 13.0418 28.008C14.4156 30.9683 17.9292 32.2543 20.8895 30.8804C21.2207 30.7267 21.5369 30.5426 21.8342 30.3305C20.5204 29.0642 19.7799 27.3169 19.7837 25.4922ZM21.4551 25.1579C22.1306 25.2588 22.8174 25.2569 23.4923 25.1521C23.5006 25.2657 23.5047 25.3802 23.5048 25.4897C23.5076 26.5982 23.1452 27.6768 22.4737 28.5588C21.8023 27.6767 21.4399 26.5982 21.4426 25.4897C21.4426 25.3819 21.4468 25.2699 21.4551 25.1579ZM20.2375 23.0668C20.4862 22.4191 20.8335 21.8137 21.2669 21.2718C20.2342 20.5667 18.9784 20.2656 17.7383 20.4258C18.22 21.5823 19.1093 22.5221 20.2375 23.0668ZM24.7032 23.0527C24.4555 22.4101 24.1102 21.8094 23.6797 21.2718C24.7004 20.574 25.9406 20.2729 27.1676 20.4249C26.691 21.5701 25.8155 22.5037 24.7032 23.0527Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9501_68796",
    x1: 2.5,
    y1: 64.5926,
    x2: 50.4216,
    y2: 59.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.150307,
    stopColor: "#44A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336372,
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548934,
    stopColor: "#0098F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74141,
    stopColor: "#009BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928887,
    stopColor: "#009BF8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_68796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.2a05cc1b3915ee972c41fb1d8608cea9.svg";
export { ForwardRef as ReactComponent };